<div id="managePopUp">
  <div class="modal-header">
    <h4 class="modal-title" [ngClass]="{'sucess': (portOutPin==1 && !tpcStatus && !isMultiline) , 'sub': (portOutPin==1 && !tpcStatus && isMultiline) , 'error':portOutPin==2 }" id="modal-basic-title">
      {{popupTitle}}
    </h4>

    <button type="button" class="close" aria-label="Close" (click)="closePopup()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          {{popupMessage}}
        </div>

        <div class="col-md-12 mt15" *ngIf="tpcStatus">
          Transaction # {{resData?.accountTransactionRefNum}}  
          </div> 

      </div>
      
      <div class="modal-body" *ngIf="!this.isMultiline && !tpcStatus">
        <div class="row" [hidden]="!portOutPin">
          <div class="col-md-12 pinbox" *ngIf="portOutPin!=2">
            {{resData?.pin}}
          </div>
          <div class="graybox" [ngClass]="{'pt15': portOutPin==2}">
            <div class="col-md-12" *ngIf="portOutPin!=2">
              <p>This PIN will expire on {{resData?.expiryTime | date :'medium'}}</p>
            </div>
            <div class="col-md-12">
              <p>Transaction # {{resData?.accountTransactionRefNum}} <a href="#" (click)="closePopup()" [routerLink]="'apps/tfb_acctmgmt/account-management/transactions/transaction-history'">Link to details</a></p>
            </div>
          </div>
          <div class="note"  >
            <strong> Note :</strong>            
            <span>{{tpopContentMultiSuccessGen1}} <a href="#" class="link-style" (click)="closePopup()" [routerLink]="'apps/tfb_acctmgmt/account-management/home'"> Manage Lines </a>  {{tpopContentMultiSuccessGen2}} </span></div>
        </div>
        </div>      
      <div class="modal-body" *ngIf="this.isMultiline">
        <div class="row" [hidden]="!portOutPin">
         
          <div class="graybox" [ngClass]="{'pt15': portOutPin==2,  'm15' : isMultiline }"> 
            <div class="col-md-12" *ngIf="transactionAction === 'bulkTpop'">
              <p>Transaction # {{transactionRef}} <a href="javascript:void(0)"  class="link-style" (click)="goToTransactionDetail(transactionRef)">Link to details</a></p>
            </div>          
            <div class="col-md-12" *ngIf="transactionAction !== 'bulkTpop'">
              <p> Transaction # {{resData?.token}}  <a href="#" (click)="closePopup()" class="link-style" [routerLink]="'apps/tfb_acctmgmt/account-management/transactions/transaction-history'">Link to details</a></p>
            </div>
          </div>
        </div>
        <div *ngIf="portOutPin==1" class="note"><strong>Note :</strong> 
          <p> {{tpopContentSuccessNote1}} <a href="javascript:void(0)" (click)="goToManageLines()" class="link-style">Manage Lines</a> {{tpopContentSuccessNote2}}</p>
        </div>
        <div [hidden]="portOutPin==1">
          <div class="row row-style">
            <div class="col-7">{{authoringContentData?.lineHeaderText}}
            </div>
            <div class="col-5">{{authoringContentData?.controlsHeaderText}}
            </div>
          </div>
          <div class="row row-style" *ngFor="let line of selectedLines">
            <div class="col-1">
              <mat-checkbox (change)="updateSelection($event, line)" [(ngModel)]="line.isSelected"></mat-checkbox>
            </div>
            <div class="col-6">{{line.msisdn}} 
            </div>
            <div class="col-5">
              <span class="restriction-text">{{checkControlMessage(line)}}</span>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!selectedActivity">
    <div class="modal-footer row" *ngIf="portOutPin==0">
      <button mat-stroked-button (click)="closePopup()" type="button"
        class="btn secondary_btn only-bdr-btn mr-2 col-lg-2"> {{authoringContentData?.cancelBtnText}} </button>
      <button (click)="genPortOutPin()" [disabled]="!activeLine && isMultiline" type="button" class="btn primary_btn order-sm-1 col-lg-3">
        {{this.isMultiline?authoringContentData?.genActionTextMulti:authoringContentData?.genText}}</button>
    </div>
  </div>

  <div *ngIf="selectedActivity">
    <div class="modal-footer row" *ngIf="portOutPin==0">
      <button mat-stroked-button (click)="closePopup()" type="button"
      class="btn secondary_btn only-bdr-btn mr-2 col-lg-2"> {{authoringContentData?.cancelBtnText}} </button>
      <button (click)="tPopCancellation()" *ngIf="!deactivated" type="button" class="btn primary_btn order-sm-1 col-lg-3">
      {{authoringContentData?.cancellationAcText}}</button>
    </div>
  </div>

  <div class="modal-footer row" *ngIf="portOutPin==1||portOutPin==2">
    <button (click)="closePopup()" type="button" class="btn primary_btn order-sm-1 col-lg-3"> Close
    </button>
  </div>


</div>